/**
 * `/$org/apps/imanage/w/$workspaceId/$folderId`: a folder of a workspace, at
 * any depth (the breadcrumb reads its parents).
 *
 * @module routes/$org.apps.imanage.w.$workspaceId_.$folderId
 */
import { createFileRoute } from "@tanstack/react-router";

import { parseIManageSearch } from "../components/apps/imanage/imanagePaths";
import { IManageWorkspaceView } from "../components/apps/imanage/IManageWorkspaceView";

function IManageFolderRoute() {
  const { workspaceId, folderId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IManageWorkspaceView
      key={`${workspaceId}/${folderId}`}
      workspaceId={workspaceId}
      folderId={folderId}
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace ?? false })}
    />
  );
}

export const Route = createFileRoute("/$org/apps/imanage/w/$workspaceId_/$folderId")({
  validateSearch: parseIManageSearch,
  component: IManageFolderRoute,
});
